import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  TextField,
} from "@mui/material";
import { useAuth } from "../../../auth/auth";
import styles from "../GenerateFatigues/GenerateFatigues.module.css";
import { generateWorkersWithMissingOFAndRWDocumentsReport } from "../../../api/apiCall";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useUKRailWeek } from "../../../hooks/useUKRailWeek";

const GenerateWorkersMissingDocuments = () => {
    const { state } = useAuth();
    const [loading, setLoading] = useState(false);
    const {currentWeek, currentYear} = useUKRailWeek();

    const { register, handleSubmit } = useForm<any>({
        defaultValues: {
            week: currentWeek,
            year: currentYear,
        },
    });

    const onSubmit = async (data: any) => {
        setLoading(true);
        const response = await generateWorkersWithMissingOFAndRWDocumentsReport(state.user?.token, data);
        if (response?.status === 200) {
            setLoading(false);
        } else {
            setLoading(false);
            toast.error("Something went wrong!");
        }
    };

    return (
        <>
            <div className={styles.formContainer}>
                <div className={styles.timesheetForm}>
                    <Box>
                        <div className={styles.timesheetFormDiv}>
                            <h2 className={styles.timesheetTitle}>Generate Missing Documents</h2>
                            <p className={styles.timesheetSubtitle}>
                                Missing Compliance Docs for week
                            </p>
                            <TextField
                                variant="outlined"
                                label="Week"
                                placeholder="Enter Week"
                                className={styles.exportButton}
                                style={{ margin: 15 }}
                                {...register("week")}
                            />
                            <TextField
                                variant="outlined"
                                label="Year"
                                placeholder="Enter Year"
                                className={styles.exportButton}
                                style={{ margin: 15 }}
                                {...register("year")}
                            />
                            <Button
                                variant="contained"
                                disabled={loading}
                                size="medium"
                                style={{
                                    boxShadow: "none",
                                    marginTop: 25,
                                    backgroundColor: "#1976d2",
                                    color: "white",
                                }}
                                className={styles.exportButton}
                                onClick={handleSubmit(onSubmit)}
                            >
                                {loading ? (
                                    <CircularProgress size={25} style={{ color: "white" }} />
                                ) : (
                                    "Export Workers Missing Docs"
                                )}
                            </Button>
                            <div
                                style={{ textAlign: "center", margin: 4, marginBottom: -10 }}
                            >
                                {loading && "This might take a while"}
                            </div>
                        </div>
                    </Box>
                </div>
            </div>
        </>
    );
};

export default GenerateWorkersMissingDocuments;
